const ExpandedComponent = ({ data }) => {
  const { app, appAll, competitor, competitorAll, keyword, keywordAll, userQuota, userQuotaAll, customAlerts } = data;
  return (
    <div className="tb-basic-inner">
      <table>
        <colgroup>
          <col width="25%" />
          <col width="25%" />
          <col width="15%" />
          <col width="15%" />
          <col width="20%" />
        </colgroup>
        <thead></thead>
        <tbody>
          <tr>
            <th>App</th>
            <td>
              {app} / {appAll}
            </td>
            <th colSpan={2}>User Quota</th>
            <td>
              {userQuota} / {userQuotaAll}
            </td>
          </tr>
          <tr>
            <th>Competitor</th>
            <td>
              {competitor} / {competitorAll}
            </td>
            <th colSpan={2}>Custom Alerts</th>
            <td>{customAlerts}</td>
          </tr>
          <tr>
            <th>Keyword</th>
            <td>
              {keyword} / {keywordAll}
            </td>
            <th colSpan={2}></th>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ExpandedComponent;
